<template>
<div class="z-main z-login">
	<div class="z-header">
		<div><router-link to="/"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('登录')}}</div>
		<div></div>
	</div>

	<div class="z-body">
		<form  autocomplete="on">
			<!-- <div class="z-form-item my-input-bg">
				<div class="z-form-label">
					手机
				</div>
				<div class="z-input-block">
					<input autocomplete="new-password" v-model="mobile" placeholder="手机号码">
				</div>
				<div @click="dialog=true">
					<img src="../../assets/kline/drop-down.png" class="z-icon" />
				</div>
			</div> -->
			<div class="z-form-item my-input-bg">
				<div class="z-form-label">
					{{$t('邮箱')}}
				</div>
				<div class="z-input-block">
					<input type="text" autocomplete="new-password" v-model="account" :placeholder="$t('邮箱')">
				</div>
				<div @click="dialog=true">
					<img src="../../assets/kline/drop-down.png" class="z-icon" />
				</div>
			</div>

			<div class="z-form-item my-input-bg" >
				<div class="z-form-label">
					{{$t('密码')}}
				</div>
				<div  class="z-input-block">
					<input autocomplete="new-password" type="password" v-model="password" :placeholder="$t('登录密码')">
				</div>
				<div>
					&nbsp;&nbsp;
					&nbsp;&nbsp;
				</div>
			</div>

			<div class="z-form-item" style="background:none;">
				<div  class="z-input-block">
					<v-checkbox dark
					v-model="is_remember"
					:label="$t('是否记住密码')+'?'"
					required
					></v-checkbox>
				</div>
			</div>

			<div class="z-form-item" style="background:none;padding:10px 0px;margin:10px 0px;">
				<div @click="login"  class="common-btn">{{$t('立即登录')}}</div>
			</div>

		</form>
		<!-- 弹框选择账号 -->
		<v-dialog v-model="dialog" scrollable max-width="300px">
			<v-card light>
			<v-card-title style="padding-bottom:10px;">{{$t('账户列表')}}</v-card-title>
			<v-card-text style="padding-top:0px;">
				<p v-if="mobileList.length==0" style="text-align:center;color:#1E1F23;">{{$t('暂无数据')}}</p>
				<ul v-else style="max-height:310px;">
					<li
					style="padding:5px 0px;"
					v-for="(item,index) in mobileList"
					@click="onselect(index)"
					><!-- {{item.nickname}}({{item.account}}) -->{{item.account}}</li>
				</ul>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat="flat" @click="dialog=false">{{$t('关闭')}}</v-btn>
			</v-card-actions>
			</v-card>
		</v-dialog>

		<div class="login-hrefs">
			<div style="text-align:right;padding:10px;color: #fff;" @click="sheet = !sheet">{{$t('忘记密码')}}？</div>
			<div><router-link to="/user/register/0">{{$t('注册')}}</router-link></div>
		</div>


		<div style="align-items: center;width: 88%;display: inline-flex;justify-content:flex-end;">
			<div>
				<div class="text-xs-center">
					<v-bottom-sheet v-model="sheet">
						<v-list style="background-color: #fff;">
							<v-list-tile  @click="sheet = false">
								<router-link style="text-align: center;width: 100%;color: #000000;" :to="{path:'/user/findPassWord'}">
									{{$t('找回密码')}}
								</router-link>
							</v-list-tile>
							<v-list-tile style="border-top: 1px solid rgb(49,49,49)"  @click="sheet = false">
								<router-link style="text-align: center;width: 100%;color: #000000;" :to="{path:'/user/emailLogin'}">
									{{$t('邮箱验证')}}
								</router-link>
							</v-list-tile>
							<!-- <v-list-tile style="border-top: 1px solid rgb(49,49,49)"  @click="sheet = false">
								<router-link style="text-align: center;width: 100%;color: #000000;" :to="{path:'/user/messageLogin'}">
									{{$t('短信验证')}}
								</router-link>
							</v-list-tile> -->
							<v-list-tile style="border-top: 1px solid rgb(49,49,49);color: #000000;"  @click="sheet = false">
								<v-list-tile-title style="text-align: center">
									{{$t('取消')}}
								</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-bottom-sheet>
				</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				sheet: false,
				account:"",// 登录名
				mobile:"", // 登录手机
				password:"", // 登录密码
				is_remember:true,//是否记住密码
				mobileList:[],//账号列表
				dialog:false
			}
		},
		created() {
			this.mobileList = this.getAccount()
		},
		methods: {
			//选择账户
			onselect(index){
				let _this = this
				_this.account = _this.mobileList[index].account
				_this.mobile = _this.mobileList[index].mobile
				_this.password = _this.mobileList[index].password
				_this.dialog = false
				_this.is_remember = true
				this.login()
			},
			//设置账户
			setAccountList(data){
				let _this = this
				var is_in = false,in_idx = 0;
				let arr = _this.mobileList
				for (var i = arr.length - 1; i >= 0; i--) {
					if (arr[i].uid==data.uid) {
						is_in = true
						in_idx = i
						// 已存在，则更新，并且选择记住密码
						if (_this.is_remember) {
							_this.mobileList[i].uid = data.uid
							_this.mobileList[i].account = _this.account
							_this.mobileList[i].nickname = data.nickname
							_this.mobileList[i].mobile = data.mobile
							_this.mobileList[i].password = _this.password
							_this.setAccount(_this.mobileList)
						}
					}
				}
				//是否记住密码
				if (_this.is_remember) {
					if (!is_in) { //不存在，则添加
						let list = {
							uid:data.uid,
							account:_this.account,
							nickname:data.nickname,
							mobile:data.mobile,
							password:_this.password
						}
						_this.mobileList.push(list)
						_this.setAccount(_this.mobileList)
					}
				}
				else {
					if (is_in) { //存在，则删除
						_this.mobileList.splice(in_idx,1);
						_this.setAccount(_this.mobileList)
					}
				}
			},
			login:function () { //登录
				let _this=this

				if(this.account=="" || this.password=="")
				{
					this.$store.commit('layer',this.$t('部分信息未填写'))
				}
				else
				{
					this.post('api/index/newLogin', {
						account: this.account,
						password:this.password
					}).then((res) => {
						this.$store.commit('layer',res.msg)
						if(res.code==0){
							this.setAccountList(res.data)
							this.setToken(res.data.token)
							this.setUid(res.data.uid)
							this.jump('/index')
						}
					})
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .theme--dark.v-icon {
    color:#000000!important;
  }
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 0px;
}
.z-mobile-list {
	z-index:99;
	background-color: #FFFFFF;
	color:#666666;
	width: 100%;
	position: absolute;
	left: 0;
	letter-spacing:2px;
	text-align: center;
}
.z-mobile-list ul{
	width: 100%;
	height: auto;
	padding: 0px;
	height: auto;
	max-height: 180px;
	overflow: scroll;
}
.z-mobile-list ul li{
	padding: 0 24px;
	width: 100%;
	height: 36px;
	line-height: 36px;
	font-size: 14px;
	list-style-type:none;
	border-bottom:1px solid #cccccc;
}
.z-login .v-input--radio-group .v-radio,
.z-login .v-input__slot {
	margin-bottom:0px;
}

.my-input-bg{
  background-color: #ddd;
}

.login-hrefs {
	display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  align-items:center;
}
.login-hrefs div{
	padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/login.vue